import { PlaiViewType, usePlai } from 'app/domains/review';
export function Playbook() {
    const { view } = usePlai();
    if (view !== PlaiViewType.Playbook) {
        return null;
    }
    return <p>Insert playbook here</p>;
}
